var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2839_5232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0423 3.37402H12.1226C13.0866 3.37402 13.8761 4.26322 13.8761 5.35186V15.6067C13.8761 16.7037 13.0949 17.5846 12.1226 17.5846H2.65727C1.69328 17.5846 0.903809 16.6954 0.903809 15.6067V5.35186C0.903809 4.25491 1.68497 3.37402 2.65727 3.37402H3.82071",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17251 2.11913C9.17251 1.18007 8.40796 0.415527 7.46891 0.415527H7.3027C6.36364 0.415527 5.5991 1.18007 5.5991 2.11913C4.66004 2.11913 3.90381 2.87536 3.90381 3.81442V4.54572H10.8678V3.81442C10.8678 2.87536 10.1116 2.11913 9.17251 2.11913Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7959 13.9114H10.9843",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7959 10.8198H10.9843",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7959 7.72852H10.9843",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2839_5232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.795,
    height: 18,
    fill: "white",
    transform: "translate(0.488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon);
export default __webpack_public_path__ + "static/media/taskicon.e156f3191666e5683c2495f7688140b6.svg";
export { ForwardRef as ReactComponent };